import React from "react";
import { Grid, Typography } from "@mui/material";
import { Fragment } from "react";

export default function ComponentHeader({
  icons = [],
  title,
  subtitle,
  buttons = [],
}) {
  return (
    <Grid
      container
      style={{ minHeight: "35px", marginTop: "4px" }}
      alignItems="center"
    >
      <Grid item xs={4}>
        <Typography style={{ fontSize: "18px", fontWeight: "600" }}>
          {title}
        </Typography>

        {!!subtitle && (
          <Typography
            variant="subtitle2"
            gutterBottom
            style={{ color: "#808080b3" }}
          >
            {subtitle}
          </Typography>
        )}
      </Grid>

      <Grid item xs={8}>
        <Grid
          container
          spacing={2}
          style={{ gap: "4px", justifyContent: "flex-end" }}
        >
          {icons.length > 0 &&
            icons.map((icon, index) => (
              <Grid alignSelf={"center"} item key={index}>
                {icon}
              </Grid>
            ))}

          {buttons.length > 0 &&
            buttons.map((button, index) => (
              <Fragment key={index}>{button}</Fragment>
            ))}
        </Grid>
      </Grid>
    </Grid>
  );
}
